module.exports = __webpack_public_path__ + "static/media/maternity2.a5ea9244.jpg";